import { useTranslation } from "react-i18next";

export const useCustomLocaleText = () => {
    const { t } = useTranslation(['apiGovernance']); // Namespace: 'apiGovernance'

    const customLocaleText = {
        toolbarDensity: t('Density'), // Custom "Density" label
        toolbarDensityLabel: t('Option'), // Label for density options
        toolbarDensityCompact: t('Compact'), // "Compact" option
        toolbarDensityStandard: t('Standard'), // "Standard" option
        toolbarDensityComfortable: t('Comfortable'), // "Comfortable" option
        toolbarColumns: t('Columns'), // "Columns" button
        toolbarFilters: t('Filters'), // "Filter" button
        columnsPanelTextFieldPlaceholder: t('Column title'), // Search input placeholder
        // Filter panel texts
        filterPanelAddFilter: t('Add Filter'), // "Add Filter" button text
        filterPanelRemoveAll: t('Remove All'), // "Remove All" button text
        filterPanelApply: t('Apply'), // "Apply" button text

        // Placeholder and dropdown labels for filter panel
        filterPanelColumns: t('Columns'), // Label for column dropdown
        filterPanelInputLabel: t('Value'), // Label for filter value input
        filterPanelInputPlaceholder: t('Filter value'), // Placeholder for value input

        columnMenuSort: t('Sort') 
    };

    return customLocaleText;
};